const STORAGE_KEYS = Object.freeze({
    CODE_VERIFIER: 'code_verifier',
    REFRESH_DUE_TIME_MS: 'refreshDueTime',
});

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null;
    }

    try {
        return window.sessionStorage;
    } catch {
        return null;
    }
};

const getItem = (key) => {
    const storage = getSessionStorage();

    if (!storage) {
        return null;
    }

    try {
        return storage.getItem(key);
    } catch {
        return null;
    }
};

const setItem = (key, value) => {
    if (value == null) {
        return;
    }

    const storage = getSessionStorage();

    if (!storage) {
        return;
    }

    try {
        storage.setItem(key, String(value));
    } catch {
        // Ignore storage failures. Auth should not crash if sessionStorage is unavailable.
    }
};

const removeItem = (key) => {
    const storage = getSessionStorage();

    if (!storage) {
        return;
    }

    try {
        storage.removeItem(key);
    } catch {
        // Ignore storage failures. Auth should not crash if sessionStorage is unavailable.
    }
};

const removeItems = (keys) => {
    keys.forEach(removeItem);
};

// Tokens are stored in HttpOnly cookies.
// JavaScript cannot and should not read them.
export const getAccessToken = () => null;
export const getRefreshToken = () => null;
export const getIdToken = () => null;

// No-op token setters.
// Tokens are managed by browser cookies, not sessionStorage.
export const setAccessToken = () => {};
export const setRefreshToken = () => {};
export const setIdToken = () => {};

// PKCE code verifier is needed during OAuth login flow.
export const getCodeVerifier = () => getItem(STORAGE_KEYS.CODE_VERIFIER);

export const setCodeVerifier = (value) => {
    setItem(STORAGE_KEYS.CODE_VERIFIER, value);
};

export const getRefreshDueTimeMs = () => {
    const value = getItem(STORAGE_KEYS.REFRESH_DUE_TIME_MS);

    if (!value) {
        return null;
    }

    const parsedValue = Number(value);

    return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : null;
};

export const setRefreshDueTimeMs = (value) => {
    const parsedValue = Number(value);

    if (!Number.isFinite(parsedValue) || parsedValue <= 0) {
        removeItem(STORAGE_KEYS.REFRESH_DUE_TIME_MS);
        return;
    }

    setItem(STORAGE_KEYS.REFRESH_DUE_TIME_MS, parsedValue);
};

export const clearRefreshDueTimeMs = () => {
    removeItem(STORAGE_KEYS.REFRESH_DUE_TIME_MS);
};

export const setTokens = () => {
    // Tokens are stored in HttpOnly cookies.
    // Once token exchange is complete, remove the PKCE code verifier.
    removeItem(STORAGE_KEYS.CODE_VERIFIER);
};

export const clearAllTokens = () => {
    removeItems([
        STORAGE_KEYS.CODE_VERIFIER,
        STORAGE_KEYS.REFRESH_DUE_TIME_MS,
    ]);
};

export const getAuthStateTokens = () => null;

export const STORAGE_KEY_NAMES = STORAGE_KEYS;